import { netural400, neturalBlack, primaryGrey } from "../../constants/color";
import { BsPencilFill } from "react-icons/bs";

const DraftBanner = ({ title, subtitle, actionLabel, onAction, actionDisabled }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        backgroundColor: "#F9F9F9",
        border: `1px solid ${primaryGrey}`,
        borderRadius: "12px",
        padding: "16px 20px",
        marginBottom: "24px",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
        <BsPencilFill color={netural400} size={18} />
        <div style={{ display: "flex", flexDirection: "column" }}>
          <label
            style={{
              fontSize: "16px",
              fontWeight: "700",
              color: neturalBlack,
            }}
          >
            {title}
          </label>
          <label style={{ fontSize: "14px", color: netural400 }}>
            {subtitle}
          </label>
        </div>
      </div>
      {actionLabel && (
        <button
          onClick={onAction}
          disabled={actionDisabled}
          style={{
            padding: "10px 24px",
            borderRadius: "12px",
            border: `1px solid ${primaryGrey}`,
            backgroundColor: actionDisabled ? "#F2F2F2" : "#fff",
            color: actionDisabled ? "#A6A6A6" : neturalBlack,
            fontSize: "14px",
            fontWeight: "600",
            cursor: actionDisabled ? "default" : "pointer",
          }}
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
};

export default DraftBanner;
